import { render, staticRenderFns } from "./TransactionMoneyFields.vue?vue&type=template&id=6a0861d7"
import script from "./TransactionMoneyFields.vue?vue&type=script&lang=js"
export * from "./TransactionMoneyFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports